// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonInput_skeleton__EGVJN"};